// import React, { useState, useEffect } from "react";
// import httpClient from "../../utils/httpClients"; // Adjust the path as needed

// function Events() {
//   const [events, setEvents] = useState([]);
//   const [filteredEvents, setFilteredEvents] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [page, setPage] = useState(1);
//   const [hasMore, setHasMore] = useState(true);
//   const [activeFilter, setActiveFilter] = useState("upcoming");
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // Form state
//   const [formData, setFormData] = useState({
//     eventName: "",
//     description: "",
//     venue: "",
//     eventDate: "",
//     startTime: "",
//     images: null
//   });
//   const [formErrors, setFormErrors] = useState({});
//   const [submitting, setSubmitting] = useState(false);
//   const [submitSuccess, setSubmitSuccess] = useState(false);
//   const [previewImages, setPreviewImages] = useState([]);

//   // Validation rules
//   const validationRules = {
//     eventName: {
//       required: true,
//       minLength: 2,
//       maxLength: 20,
//       pattern: /^[a-zA-Z0-9\s\-&.,!()]+$/ // Alphanumeric, spaces, and common punctuation
//     },
//     description: {
//       required: true,
//       minLength: 10,
//       maxLength: 50
//     },
//     venue: {
//       required: true,
//       minLength: 3,
//       maxLength: 30
//     },
//     eventDate: {
//       required: true,
//       futureDate: true
//     },
//     startTime: {
//       required: true
//     },
//     images: {
//       maxFiles: 5,
//       maxFileSize: 5 * 1024 * 1024, // 5MB
//       allowedTypes: ['image/jpeg', 'image/jpg', 'image/png', 'image/gif', 'image/webp']
//     }
//   };

//   const fetchEvents = async (loadMore = false) => {
//     try {
//       setLoading(true);
//       const pageToUse = loadMore ? page + 1 : 1;
//       const pageSize = 10;

//       const res = await httpClient.get(
//         `/common/event/get-events?filter=${activeFilter}&page=${pageToUse}&limit=${pageSize}`
//       );

//       if (res.data && res.data.success) {
//         const newData = res.data.data?.events || [];
//         if (loadMore) {
//           setEvents((prev) => [...prev, ...newData]);
//           setPage(pageToUse);
//         } else {
//           setEvents(newData);
//           setPage(1);
//         }
//         setHasMore(newData.length >= pageSize);
//       } else {
//         console.error("Failed to fetch events");
//       }
//     } catch (err) {
//       console.error("Error fetching events:", err);
//       setFormErrors({ fetch: "Failed to load events. Please try again." });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchEvents();
//   }, [activeFilter]);

//   // Filter events based on active tab
//   useEffect(() => {
//     setFilteredEvents(events);
//   }, [events]);

//   const handleFilterChange = (filter) => {
//     setActiveFilter(filter);
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'long',
//       day: 'numeric'
//     });
//   };

//   const formatTime = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleTimeString('en-US', {
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   // Enhanced validation functions
//   const validateField = (name, value, files = null) => {
//     const rules = validationRules[name];
//     if (!rules) return "";

//     // Required validation
//     if (rules.required) {
//       if (!value || (typeof value === 'string' && value.trim() === '')) {
//         return `${name.replace(/([A-Z])/g, ' $1')} is required`;
//       }
//     }

//     switch (name) {
//       case 'eventName':
//         if (value.length < rules.minLength) {
//           return `Event name must be at least ${rules.minLength} characters`;
//         }
//         if (value.length > rules.maxLength) {
//           return `Event name must be less than ${rules.maxLength} characters`;
//         }
//         if (!rules.pattern.test(value)) {
//           return 'Event name contains invalid characters';
//         }
//         break;

//       case 'description':
//         if (value.length < rules.minLength) {
//           return `Description must be at least ${rules.minLength} characters`;
//         }
//         if (value.length > rules.maxLength) {
//           return `Description must be less than ${rules.maxLength} characters`;
//         }
//         break;

//       case 'venue':
//         if (value.length < rules.minLength) {
//           return `Venue must be at least ${rules.minLength} characters`;
//         }
//         if (value.length > rules.maxLength) {
//           return `Venue must be less than ${rules.maxLength} characters`;
//         }
//         break;

//       case 'eventDate':
//         if (rules.futureDate) {
//           const selectedDate = new Date(value);
//           const today = new Date();
//           today.setHours(0, 0, 0, 0);
//           if (selectedDate < today) {
//             return 'Event date must be in the future';
//           }
//         }
//         break;

//       case 'startTime':
//         if (value) {
//           const [hours, minutes] = value.split(':').map(Number);
//           if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
//             return 'Please enter a valid time';
//           }
//         }
//         break;

//       case 'images':
//         if (files && files.length > 0) {
//           // Check number of files
//           if (files.length > rules.maxFiles) {
//             return `Maximum ${rules.maxFiles} images allowed`;
//           }

//           // Check file types and sizes
//           for (let i = 0; i < files.length; i++) {
//             const file = files[i];

//             // Check file type
//             if (!rules.allowedTypes.includes(file.type)) {
//               return `Invalid file type: ${file.name}. Allowed types: JPEG, JPG, PNG, GIF, WEBP`;
//             }

//             // Check file size
//             if (file.size > rules.maxFileSize) {
//               return `File too large: ${file.name}. Maximum size: 5MB`;
//             }
//           }
//         }
//         break;

//       default:
//         break;
//     }

//     return "";
//   };

//   const handleInputChange = (e) => {
//     const { name, value, files } = e.target;

//     let fieldValue = value;
//     let fieldFiles = null;

//     if (name === "images") {
//       fieldFiles = files;
//       // Store all selected files in formData
//       setFormData(prev => ({ ...prev, [name]: files }));

//       // Generate preview URLs and cleanup old ones
//       if (files && files.length > 0) {
//         // Revoke old preview URLs to prevent memory leaks
//         previewImages.forEach(url => URL.revokeObjectURL(url));

//         const imagePreviews = Array.from(files).map((file) =>
//           URL.createObjectURL(file)
//         );
//         setPreviewImages(imagePreviews);
//       } else {
//         previewImages.forEach(url => URL.revokeObjectURL(url));
//         setPreviewImages([]);
//       }
//     } else {
//       setFormData(prev => ({ ...prev, [name]: value }));
//     }

//     // Validate field in real-time
//     const error = validateField(name, fieldValue, fieldFiles);
//     setFormErrors(prev => ({
//       ...prev,
//       [name]: error
//     }));
//   };

//   const validateForm = () => {
//     const errors = {};

//     // Validate all fields
//     Object.keys(formData).forEach(fieldName => {
//       const error = validateField(
//         fieldName,
//         formData[fieldName],
//         fieldName === 'images' ? formData.images : null
//       );
//       if (error) {
//         errors[fieldName] = error;
//       }
//     });

//     // Additional cross-field validation
//     if (formData.eventDate && formData.startTime) {
//       const eventDateTime = new Date(`${formData.eventDate}T${formData.startTime}`);
//       const now = new Date();

//       if (eventDateTime <= now) {
//         errors.eventTime = 'Event date and time must be in the future';
//       }
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       // Scroll to first error
//       const firstErrorField = document.querySelector('.error-text');
//       if (firstErrorField) {
//         firstErrorField.scrollIntoView({ behavior: 'smooth', block: 'center' });
//       }
//       return;
//     }

//     setSubmitting(true);

//     try {
//       // Create FormData for file upload
//       const submitData = new FormData();
//       submitData.append("eventName", formData.eventName.trim());
//       submitData.append("description", formData.description.trim());
//       submitData.append("venue", formData.venue.trim());
//       submitData.append("eventDate", formData.eventDate);
//       submitData.append("startTime", formData.startTime);

//       if (formData.images) {
//         // Append all images
//         for (let i = 0; i < formData.images.length; i++) {
//           submitData.append("images", formData.images[i]);
//         }
//       }

//       const res = await httpClient.post("/common/event/create-event", submitData, {
//         headers: {
//           "Content-Type": "multipart/form-data"
//         }
//       });

//       if (res.data && res.data.success) {
//         setSubmitSuccess(true);
//         // Reset form
//         resetForm();

//         // Refresh events list
//         setTimeout(() => {
//           fetchEvents();
//           setIsModalOpen(false);
//           setSubmitSuccess(false);
//         }, 2000);
//       } else {
//         throw new Error(res.data?.message || "Failed to create event");
//       }
//     } catch (err) {
//       console.error("Error creating event:", err);
//       setFormErrors({
//         submit: err.response?.data?.message || "Failed to create event. Please try again."
//       });
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const resetForm = () => {
//     setFormData({
//       eventName: "",
//       description: "",
//       venue: "",
//       eventDate: "",
//       startTime: "",
//       images: null
//     });
//     // Cleanup preview URLs
//     previewImages.forEach(url => URL.revokeObjectURL(url));
//     setPreviewImages([]);
//     setFormErrors({});
//     setSubmitSuccess(false);
//   };

//   const handleModalClose = () => {
//     resetForm();
//     setIsModalOpen(false);
//   };
//   useEffect(() => {
//   if (isModalOpen) {
//     document.body.style.overflow = 'hidden';
//     document.body.style.touchAction = 'none';
//   } else {
//     document.body.style.overflow = 'unset';
//     document.body.style.touchAction = 'auto';
//   }

//   return () => {
//     document.body.style.overflow = 'unset';
//     document.body.style.touchAction = 'auto';
//   };
// }, [isModalOpen]);

//   if (loading && !events.length) {
//     return (
//       <div className="content-inner pb-0 container-fluid" id="page_layout">
//         <div
//           className="d-flex justify-content-center align-items-center"
//           style={{ height: "50vh" }}
//         >
//           <div className="spinner-border text-primary" role="status">
//             <span className="sr-only">Loading...</span>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="content-inner pb-0 container-fluid" id="page_layout">
//       <div className="row row--grid">
//         {/* breadcrumb */}
//         <div className="col-12">
//           <ul className="breadcrumb">
//             <li className="breadcrumb__item">
//               <a href="index.html">Home</a>
//             </li>
//             <li className="breadcrumb__item breadcrumb__item--active">
//               Events
//             </li>
//           </ul>
//         </div>
//         {/* end breadcrumb */}

//         {/* title */}
//         <div className="col-12 d-flex justify-content-between align-items-center mt-4">
//           <div className="main__title main__title--page mt-0">
//             <h2 className="card-title text-capitalize mt-0">Events</h2>
//           </div>
//           <a
//             onClick={() => setIsModalOpen(true)}
//             className="release__buy open-modal filter open-modal"
//             style={{ cursor: 'pointer' }}
//           >
//             Schedule Event
//           </a>
//         </div>
//         {/* end title */}
//       </div>

//       <div className="row row--grid">
//         <div className="col-12">
//           <div
//             className="slider-radio events mt-4"
//             style={{ width: "fit-content" }}
//           >
//             <input
//               type="radio"
//               name="grade"
//               id="upcoming"
//               checked={activeFilter === "upcoming"}
//               onChange={() => handleFilterChange("upcoming")}
//             />
//             <label htmlFor="upcoming">
//               Upcoming
//             </label>

//             <input
//               type="radio"
//               name="grade"
//               id="today"
//               checked={activeFilter === "today"}
//               onChange={() => handleFilterChange("today")}
//             />
//             <label htmlFor="today">Today</label>

//             <input
//               type="radio"
//               name="grade"
//               id="past"
//               checked={activeFilter === "past"}
//               onChange={() => handleFilterChange("past")}
//             />
//             <label htmlFor="past">Past</label>

//             <div className="sliding-piece" />
//           </div>

//           {/* Display fetch errors */}
//           {formErrors.fetch && (
//             <div className="alert alert-danger" role="alert">
//               {formErrors.fetch}
//             </div>
//           )}

//           {filteredEvents.length > 0 ? (
//             <>
//               <div className="row row--grid">
//                 {filteredEvents.map((event) => (
//                   <div key={event._id} className="col-12 col-md-6 col-xl-4 mb-3">
//                     <div
//                       className="event"
//                       style={{
//                         background: `url(${event.images || '${process.env.PUBLIC_URL}/img/events/event1.jpg'}) center center / cover no-repeat`,
//                       }}
//                     >
//                       <a className="event__share">
//                       </a>
//                       <span className="event__date">{formatDate(event.eventDate)}</span>
//                       <span className="event__time">{event.startTime}</span>
//                       <h3 className="event__title" style={{cursor:"pointer"}}>
//                         <a>{event.eventName}</a>
//                       </h3>
//                       <p className="event__address">
//                         {event.venue}
//                       </p>
//                     </div>
//                   </div>
//                 ))}
//               </div>

//               {hasMore && (
//                 <div className="row row--grid">
//                   <div className="col-12">
//                     <button
//                       className="main__load"
//                       type="button"
//                       onClick={() => fetchEvents(true)}
//                       disabled={loading}
//                     >
//                       {loading ? "Loading..." : "Load more"}
//                     </button>
//                   </div>
//                 </div>
//               )}
//             </>
//           ) : (
//             <div className="row">
//               <div className="col-12 text-center py-5">
//                 <p>No events found.</p>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Modal for scheduling events */}
//       {isModalOpen && (
//         <div className="modal-overlay">
//           <div className="modal-content zoom-anim-dialog modal modal--form eventss">
//             <button className="modal__close" onClick={handleModalClose}>
//               <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
//                 <path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"/>
//               </svg>
//             </button>

//             <h3 className="sign__title border-bottom pb-3">Schedule Event</h3>

//             {/* Success Message */}
//             {submitSuccess && (
//               <div className="alert alert-success" role="alert">
//                 Event scheduled successfully!
//               </div>
//             )}

//             {/* Submit Error Message */}
//             {formErrors.submit && (
//               <div className="alert alert-danger" role="alert">
//                 {formErrors.submit}
//               </div>
//             )}

//             <form onSubmit={handleSubmit}>
//               <div className="sign__group sign__group--row">
//                 <div className="col-lg-6">
//                   <div className="form-group">
//                     <label className="form-label" htmlFor="eventName">Event Name *</label>
//                     <input
//                       type="text"
//                       className={`form-control ${formErrors.eventName ? 'is-invalid' : ''}`}
//                       id="eventName"
//                       name="eventName"
//                       value={formData.eventName}
//                       onChange={handleInputChange}
//                       placeholder="Enter Event Name"
//                       maxLength={validationRules.eventName.maxLength}
//                     />
//                     <div className="form-text text-muted">
//                       {formData.eventName.length}/{validationRules.eventName.maxLength} characters
//                     </div>
//                     {formErrors.eventName && <span className="error-text">{formErrors.eventName}</span>}
//                   </div>
//                 </div>

//                 <div className="col-lg-6">
//                   <div className="form-group">
//                     <label className="form-label" htmlFor="eventDate">Event Date *</label>
//                     <input
//                       type="date"
//                       className={`form-control ${formErrors.eventDate ? 'is-invalid' : ''}`}
//                       id="eventDate"
//                       name="eventDate"
//                       value={formData.eventDate}
//                       onChange={handleInputChange}
//                       min={new Date().toISOString().split('T')[0]} // Today's date
//                     />
//                     {formErrors.eventDate && <span className="error-text">{formErrors.eventDate}</span>}
//                   </div>
//                 </div>

//                 <div className="col-lg-6">
//                   <div className="form-group">
//                     <label className="form-label" htmlFor="startTime">Start Time *</label>
//                     <input
//                       type="time"
//                       className={`form-control ${formErrors.startTime ? 'is-invalid' : ''}`}
//                       id="startTime"
//                       name="startTime"
//                       value={formData.startTime}
//                       onChange={handleInputChange}
//                     />
//                     {formErrors.startTime && <span className="error-text">{formErrors.startTime}</span>}
//                   </div>
//                 </div>

//                 <div className="col-lg-6">
//                   <div className="form-group">
//                     <label className="form-label" htmlFor="venue">Venue *</label>
//                     <input
//                       type="text"
//                       className={`form-control ${formErrors.venue ? 'is-invalid' : ''}`}
//                       id="venue"
//                       name="venue"
//                       value={formData.venue}
//                       onChange={handleInputChange}
//                       placeholder="Enter Venue"
//                       maxLength={validationRules.venue.maxLength}
//                     />
//                     <div className="form-text text-muted">
//                       {formData.venue.length}/{validationRules.venue.maxLength} characters
//                     </div>
//                     {formErrors.venue && <span className="error-text">{formErrors.venue}</span>}
//                   </div>
//                 </div>

//                 <div className="col-lg-12">
//                   <div className="form-group">
//                     <label className="form-label" htmlFor="description">Description *</label>
//                     <textarea
//                       className={`form-control ${formErrors.description ? 'is-invalid' : ''}`}
//                       id="description"
//                       name="description"
//                       rows={5}
//                       value={formData.description}
//                       onChange={handleInputChange}
//                       placeholder="Enter Event Description"
//                       maxLength={validationRules.description.maxLength}
//                     />
//                     <div className="form-text text-muted">
//                       {formData.description.length}/{validationRules.description.maxLength} characters
//                     </div>
//                     {formErrors.description && <span className="error-text">{formErrors.description}</span>}
//                   </div>
//                 </div>

//                 <div className="col-lg-12">
//                   <div className="form-group">
//                     <label className="form-label">Event Images</label>
//                     <div className="upload__box">
//                       <div className="upload__btn-box">
//                         <label className="upload__btn">
//                           <p>
//                             <i className="fa-solid fa-upload" /> Upload images
//                           </p>
//                           <input
//                             type="file"
//                             id="images"
//                             name="images"
//                             multiple
//                             data-max_length={validationRules.images.maxFiles}
//                             className="upload__inputfile"
//                             onChange={handleInputChange}
//                             accept="image/jpeg, image/jpg, image/png, image/gif, image/webp"
//                           />
//                         </label>
//                       </div>
//                       <div className="form-text text-muted">
//                         Maximum {validationRules.images.maxFiles} images, 5MB each. Allowed: JPEG, JPG, PNG, GIF, WEBP
//                       </div>
//                       {formErrors.images && <span className="error-text">{formErrors.images}</span>}

//                       {previewImages.length > 0 && (
//                         <div className="upload__img-wrap">
//                           {previewImages.map((img, index) => (
//                             <div key={index} className="upload__img-box">
//                               <img src={img} alt={`upload-preview-${index}`} className="upload__img" />
//                             </div>
//                           ))}
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>

//                 {/* Cross-field validation error */}
//                 {formErrors.eventTime && (
//                   <div className="col-lg-12">
//                     <div className="alert alert-danger">
//                       {formErrors.eventTime}
//                     </div>
//                   </div>
//                 )}

//                 <div className="col-lg-12">
//                   <button
//                     type="submit"
//                     className="release__buy"
//                     disabled={submitting}
//                   >
//                     {submitting ? "Scheduling..." : "Schedule Event"}
//                   </button>
//                 </div>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       <style jsx>{`
//         .modal-overlay {
//           position: fixed;
//           top: 0;
//           left: 0;
//           right: 0;
//           bottom: 0;
//           background-color: rgba(0, 0, 0, 0.7);
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           z-index: 1000;
//           padding: 20px;
//         }

//         .modal-content {
//     background: white;
//     border-radius: 12px;
//     padding: 27px;
//     width: 100%;
//     max-width: 660px;
//     max-height: 72vh;
//     overflow-y: auto;
//     position: relative;
//     margin-top: 0px;
// }
//         .modal__close {
//           position: absolute;
//           top: 15px;
//           right: 15px;
//           background: none;
//           border: none;
//           cursor: pointer;
//           color: #777;
//           transition: color 0.3s;
//           width: 24px;
//           height: 24px;
//           padding: 0;
//         }

//         .modal__close:hover {
//           color: #333;
//         }

//         .error-text {
//           color: #dc3545;
//           font-size: 0.875rem;
//           margin-top: 0.25rem;
//           display: block;
//         }

//         .form-control.is-invalid {
//           border-color: #dc3545;
//           box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
//         }

//         .upload__img-wrap {
//           display: flex;
//           flex-wrap: wrap;
//           gap: 10px;
//           margin-top: 15px;
//         }

//         .upload__img-box {
//           width: 100px;
//           height: 100px;
//           border-radius: 8px;
//           overflow: hidden;
//           border: 2px solid #e9ecef;
//           position: relative;
//         }

//         .upload__img {
//           width: 100%;
//           height: 100%;
//           object-fit: cover;
//         }

//         .main__load:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//         }

//         .alert {
//           border-radius: 8px;
//           padding: 12px 16px;
//           margin-bottom: 16px;
//           border: 1px solid transparent;
//         }

//         .alert-success {
//           background-color: #d1e7dd;
//           border-color: #badbcc;
//           color: #0f5132;
//         }

//         .alert-danger {
//           background-color: #f8d7da;
//           border-color: #f5c2c7;
//           color: #842029;
//         }

//         .form-text {
//           font-size: 0.875rem;
//           margin-top: 0.25rem;
//         }

//         .release__buy:disabled {
//           opacity: 0.6;
//           cursor: not-allowed;
//         }
//       `}</style>
//     </div>
//   );
// }

// export default Events;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import httpClient from "../../utils/httpClients"; // Adjust the path as needed

function Events() {
  const navigate = useNavigate();
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [activeFilter, setActiveFilter] = useState("upcoming");
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    eventName: "",
    description: "",
    venue: "",
    eventDate: "",
    startTime: "",
    image: null, // Single image
  });
  const [formErrors, setFormErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [previewImage, setPreviewImage] = useState(null); // Single preview

  // Validation rules
  const validationRules = {
    eventName: {
      required: true,
      pattern: /^[a-zA-Z0-9\s\-&.,!()]+$/, // Only valid characters
    },
    description: {
      required: true,
      minLength: 10,
      maxLength: 100,
    },
    venue: {
      required: true,
      pattern: /^[a-zA-Z0-9\s\-&.,!()]+$/, // Only valid characters
    },
    eventDate: {
      required: true,
      futureDate: true,
    },
    startTime: {
      required: true,
    },
    image: {
      maxFileSize: 5 * 1024 * 1024, // 5MB
      allowedTypes: [
        "image/jpeg",
        "image/jpg",
        "image/png",
        "image/gif",
        "image/webp",
      ],
    },
  };

  const PAGE_SIZE = 10;

  const fetchEvents = async (loadMore = false) => {
    try {
      setLoading(true);
      const pageToUse = loadMore ? page + 1 : 1;

      const res = await httpClient.get(
        `/common/event/get-events?filter=${activeFilter}&page=${pageToUse}&limit=${PAGE_SIZE}`,
      );

      if (res.data && res.data.success) {
        const newData = res.data.data?.events || [];
        const total = res.data.data?.total || 0;
        setTotalPages(Math.ceil(total / PAGE_SIZE));

        if (loadMore) {
          setEvents((prev) => [...prev, ...newData]);
          setPage(pageToUse);
        } else {
          setEvents(newData);
          setPage(1);
        }
      } else {
        console.error("Failed to fetch events");
      }
    } catch (err) {
      console.error("Error fetching events:", err);
      setFormErrors({ fetch: "Failed to load events. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEvents();
  }, [activeFilter]);

  useEffect(() => {
    setFilteredEvents(events);
  }, [events]);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
    setPage(1);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  // Validation
  const validateField = (name, value, file = null) => {
    const rules = validationRules[name];
    if (!rules) return "";

    if (rules.required) {
      if (!value || (typeof value === "string" && value.trim() === "")) {
        return `${name.replace(/([A-Z])/g, " $1")} is required`;
      }
    }

    switch (name) {
      case "eventName":
      case "venue":
        if (!rules.pattern.test(value)) {
          return `${name === "eventName" ? "Event name" : "Venue"} contains invalid characters`;
        }
        break;

      case "description":
        if (value.length < rules.minLength) {
          return `Description must be at least ${rules.minLength} characters`;
        }
        if (value.length > rules.maxLength) {
          return `Description must be less than ${rules.maxLength} characters`;
        }
        break;

      case "eventDate":
        if (rules.futureDate) {
          const selectedDate = new Date(value);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (selectedDate < today) {
            return "Event date must be in the future";
          }
        }
        break;

      case "startTime":
        if (value) {
          const [hours, minutes] = value.split(":").map(Number);
          if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
            return "Please enter a valid time";
          }
        }
        break;

      case "image":
        if (file) {
          if (!rules.allowedTypes.includes(file.type)) {
            return `Invalid file type: ${file.name}. Allowed: JPEG, JPG, PNG, GIF, WEBP`;
          }
          if (file.size > rules.maxFileSize) {
            return `File too large: ${file.name}. Max: 5MB`;
          }
        }
        break;

      default:
        break;
    }

    return "";
  };

  const handleInputChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "image") {
      const file = files[0];
      setFormData((prev) => ({ ...prev, image: file }));

      // Revoke old preview
      if (previewImage) URL.revokeObjectURL(previewImage);

      if (file) {
        setPreviewImage(URL.createObjectURL(file));
      } else {
        setPreviewImage(null);
      }

      const error = validateField(name, file ? "present" : "", file);
      setFormErrors((prev) => ({ ...prev, [name]: error }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
      const error = validateField(name, value);
      setFormErrors((prev) => ({ ...prev, [name]: error }));
    }
  };

  const removeImage = () => {
    if (previewImage) URL.revokeObjectURL(previewImage);
    setFormData((prev) => ({ ...prev, image: null }));
    setPreviewImage(null);
    setFormErrors((prev) => ({ ...prev, image: "" }));
  };

  const validateForm = () => {
    const errors = {};

    Object.keys(formData).forEach((fieldName) => {
      const value = formData[fieldName];
      const file = fieldName === "image" ? value : null;
      const error = validateField(fieldName, value, file);
      if (error) errors[fieldName] = error;
    });

    if (formData.eventDate && formData.startTime) {
      const eventDateTime = new Date(
        `${formData.eventDate}T${formData.startTime}`,
      );
      const now = new Date();
      if (eventDateTime <= now) {
        errors.eventTime = "Event date and time must be in the future";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      const firstErrorField = document.querySelector(".error-text");
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      }
      return;
    }

    setSubmitting(true);

    try {
      const submitData = new FormData();
      submitData.append("eventName", formData.eventName.trim());
      submitData.append("description", formData.description.trim());
      submitData.append("venue", formData.venue.trim());
      submitData.append("eventDate", formData.eventDate);
      submitData.append("startTime", formData.startTime);
      if (formData.image) {
        submitData.append("images", formData.image);
      }

      const res = await httpClient.post(
        "/common/event/create-event",
        submitData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        },
      );

      if (res.data && res.data.success) {
        setSubmitSuccess(true);
        resetForm();
        setTimeout(() => {
          fetchEvents();
          setIsModalOpen(false);
          setSubmitSuccess(false);
        }, 2000);
      } else {
        throw new Error(res.data?.message || "Failed to create event");
      }
    } catch (err) {
      console.error("Error creating event:", err);
      setFormErrors({
        submit:
          err.response?.data?.message ||
          "Failed to create event. Please try again.",
      });
    } finally {
      setSubmitting(false);
    }
  };

  const resetForm = () => {
    setFormData({
      eventName: "",
      description: "",
      venue: "",
      eventDate: "",
      startTime: "",
      image: null,
    });
    if (previewImage) URL.revokeObjectURL(previewImage);
    setPreviewImage(null);
    setFormErrors({});
    setSubmitSuccess(false);
  };

  const handleModalClose = () => {
    resetForm();
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = "hidden";
      document.body.style.touchAction = "none";
    } else {
      document.body.style.overflow = "unset";
      document.body.style.touchAction = "auto";
    }
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.touchAction = "auto";
    };
  }, [isModalOpen]);

  // Pagination handlers
  const goToPage = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages && newPage !== page) {
      setPage(newPage);
      fetchEvents(true);
    }
  };

  if (loading && !events.length) {
    return (
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div
          className="d-flex justify-content-center align-items-center"
          style={{ height: "50vh" }}
        >
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="content-inner pb-0 container-fluid" id="page_layout">
      <div className="row row--grid">
        {/* breadcrumb */}
        <div className="col-12">
          <ul className="breadcrumb">
            <li className="breadcrumb__item">
              <a href="index.html">Home</a>
            </li>
            <li className="breadcrumb__item breadcrumb__item--active">
              Events
            </li>
          </ul>
        </div>
        {/* end breadcrumb */}

        {/* title */}
        <div className="col-12 d-flex justify-content-between align-items-center mt-4">
          <div className="main__title main__title--page mt-0">
            <h2 className="card-title text-capitalize mt-0">Events</h2>
          </div>
          <a
            onClick={() => setIsModalOpen(true)}
            className="release__buy open-modal filter open-modal"
            style={{ cursor: "pointer" }}
          >
            Schedule Event
          </a>
        </div>
        {/* end title */}
      </div>

      <div className="row row--grid">
        <div className="col-12">
          <div
            className="slider-radio events mt-4"
            style={{ width: "fit-content" }}
          >
            <input
              type="radio"
              name="grade"
              id="upcoming"
              checked={activeFilter === "upcoming"}
              onChange={() => handleFilterChange("upcoming")}
            />
            <label htmlFor="upcoming">Upcoming</label>

            <input
              type="radio"
              name="grade"
              id="today"
              checked={activeFilter === "today"}
              onChange={() => handleFilterChange("today")}
            />
            <label htmlFor="today">Today</label>

            <input
              type="radio"
              name="grade"
              id="past"
              checked={activeFilter === "past"}
              onChange={() => handleFilterChange("past")}
            />
            <label htmlFor="past">Past</label>

            <div className="sliding-piece" />
          </div>

          {formErrors.fetch && (
            <div className="alert alert-danger" role="alert">
              {formErrors.fetch}
            </div>
          )}

          {filteredEvents.length > 0 ? (
            <>
              <div className="row row--grid">
                {filteredEvents.map((event) => (
                  <div
                    key={event._id}
                    className="col-12 col-md-6 col-xl-4 mb-3"
                    onClick={() => navigate(`/events/${event._id}`, { state: { event } })}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        navigate(`/events/${event._id}`, { state: { event } });
                      }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <div
                      className="event"
                      style={{
                        background: `url(${event.images?.[0] || `${process.env.PUBLIC_URL}/img/events/event1.jpg`}) center center / cover no-repeat`,
                      }}
                    >
                      <a className="event__share"></a>
                      <span className="event__date">
                        {formatDate(event.eventDate)}
                      </span>
                      <span className="event__time">{event.startTime}</span>
                      <h3
                        className="event__title"
                        style={{ cursor: "pointer" }}
                      >
                        <a>{event.eventName}</a>
                      </h3>
                      <p className="event__address">{event.venue}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="row row--grid mt-4">
                  <div className="col-12">
                    <nav aria-label="Page navigation">
                      <ul className="pagination justify-content-center">
                        <li
                          className={`page-item ${page === 1 ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => goToPage(page - 1)}
                            disabled={page === 1}
                          >
                            Previous
                          </button>
                        </li>
                        {[...Array(totalPages)].map((_, i) => (
                          <li
                            key={i + 1}
                            className={`page-item ${page === i + 1 ? "active" : ""}`}
                          >
                            <button
                              className="page-link"
                              onClick={() => goToPage(i + 1)}
                            >
                              {i + 1}
                            </button>
                          </li>
                        ))}
                        <li
                          className={`page-item ${page === totalPages ? "disabled" : ""}`}
                        >
                          <button
                            className="page-link"
                            onClick={() => goToPage(page + 1)}
                            disabled={page === totalPages}
                          >
                            Next
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className="row">
              <div className="col-12 text-center py-5">
                <p>No events found.</p>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content zoom-anim-dialog modal modal--form eventss">
            <button className="modal__close" onClick={handleModalClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path d="M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z" />
              </svg>
            </button>

            <h3 className="sign__title border-bottom pb-3">Schedule Event</h3>

            {submitSuccess && (
              <div className="alert alert-success" role="alert">
                Event scheduled successfully!
              </div>
            )}

            {formErrors.submit && (
              <div className="alert alert-danger" role="alert">
                {formErrors.submit}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="sign__group sign__group--row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="eventName">
                      Event Name *
                    </label>
                    <input
                      type="text"
                      className={`form-control ${formErrors.eventName ? "is-invalid" : ""}`}
                      id="eventName"
                      name="eventName"
                      value={formData.eventName}
                      onChange={handleInputChange}
                      placeholder="Enter Event Name"
                    />
                    {formErrors.eventName && (
                      <span className="error-text">{formErrors.eventName}</span>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="eventDate">
                      Event Date *
                    </label>
                    <input
                      type="date"
                      className={`form-control ${formErrors.eventDate ? "is-invalid" : ""}`}
                      id="eventDate"
                      name="eventDate"
                      value={formData.eventDate}
                      onChange={handleInputChange}
                      min={new Date().toISOString().split("T")[0]}
                    />
                    {formErrors.eventDate && (
                      <span className="error-text">{formErrors.eventDate}</span>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="startTime">
                      Start Time *
                    </label>
                    <input
                      type="time"
                      className={`form-control ${formErrors.startTime ? "is-invalid" : ""}`}
                      id="startTime"
                      name="startTime"
                      value={formData.startTime}
                      onChange={handleInputChange}
                    />
                    {formErrors.startTime && (
                      <span className="error-text">{formErrors.startTime}</span>
                    )}
                  </div>
                </div>

                <div className="col-lg-6">
                  <div className="form-group">
                    <label className="form-label" htmlFor="venue">
                      Venue *
                    </label>
                    <input
                      type="text"
                      className={`form-control ${formErrors.venue ? "is-invalid" : ""}`}
                      id="venue"
                      name="venue"
                      value={formData.venue}
                      onChange={handleInputChange}
                      placeholder="Enter Venue"
                    />
                    {formErrors.venue && (
                      <span className="error-text">{formErrors.venue}</span>
                    )}
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="form-label" htmlFor="description">
                      Description *
                    </label>
                    <textarea
                      className={`form-control ${formErrors.description ? "is-invalid" : ""}`}
                      id="description"
                      name="description"
                      rows={5}
                      value={formData.description}
                      onChange={handleInputChange}
                      placeholder="Enter Event Description"
                      maxLength={validationRules.description.maxLength}
                    />
                    <div className="form-text text-muted">
                      {formData.description.length}/
                      {validationRules.description.maxLength} characters
                    </div>
                    {formErrors.description && (
                      <span className="error-text">
                        {formErrors.description}
                      </span>
                    )}
                  </div>
                </div>

                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="form-label">Event Image</label>
                    <div className="upload__box">
                      <div className="upload__btn-box">
                        <label className="upload__btn">
                          <p>
                            <i className="fa-solid fa-upload" /> Upload image
                          </p>
                          <input
                            type="file"
                            id="image"
                            name="image"
                            className="upload__inputfile"
                            onChange={handleInputChange}
                            accept="image/jpeg, image/jpg, image/png, image/gif, image/webp"
                          />
                        </label>
                      </div>
                      <div className="form-text text-muted">
                        Max 5MB. Allowed: JPEG, JPG, PNG, GIF, WEBP
                      </div>
                      {formErrors.image && (
                        <span className="error-text">{formErrors.image}</span>
                      )}

                      {/* ---------- IMAGE PREVIEW (cross icon fully outside) ---------- */}
                      {previewImage && (
                        <div
                          className="upload__img-wrap"
                          style={{ marginTop: "15px" }}
                        >
                          <div
                            className="upload__img-box"
                            style={{
                              position: "relative",
                              width: "180px", // larger preview
                              height: "180px",
                              borderRadius: "12px",
                              overflow: "hidden",
                              border: "2px solid #e9ecef",
                              display: "inline-block",
                            }}
                          >
                            <img
                              src={previewImage}
                              alt="preview"
                              className="upload__img"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />

                            {/* Cross icon – completely outside the image */}
                            <button
                              type="button"
                              onClick={removeImage}
                              style={{
                                position: "absolute",
                                top: "0px",
                                right: "7px",
                                background: "#dc3545",
                                color: "#fff",
                                border: "none",
                                borderRadius: "50%",
                                width: "36px",
                                height: "36px",
                                fontSize: "20px",
                                fontWeight: "bold",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                boxShadow: "0 3px 8px rgba(0,0,0,0.25)",
                                zIndex: 10,
                              }}
                              aria-label="Remove image"
                            >
                              ×
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {formErrors.eventTime && (
                  <div className="col-lg-12">
                    <div className="alert alert-danger">
                      {formErrors.eventTime}
                    </div>
                  </div>
                )}

                <div className="col-lg-12">
                  <button
                    type="submit"
                    className="release__buy"
                    disabled={submitting}
                  >
                    {submitting ? "Scheduling..." : "Schedule Event"}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      )}

      <style jsx>{`
        .modal-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0, 0, 0, 0.7);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
          padding: 20px;
        }
        .modal-content {
          background: white;
          border-radius: 12px;
          padding: 27px;
          width: 100%;
          max-width: 660px;
          max-height: 72vh;
          overflow-y: auto;
          position: relative;
          margin-top: -25px;
        }
        .modal__close {
          position: absolute;
          top: 15px;
          right: 15px;
          background: none;
          border: none;
          cursor: pointer;
          color: #777;
          width: 24px;
          height: 24px;
          padding: 0;
        }
        .modal__close:hover {
          color: #333;
        }
        .error-text {
          color: #dc3545;
          font-size: 0.875rem;
          margin-top: 0.25rem;
          display: block;
        }
        .form-control.is-invalid {
          border-color: #dc3545;
          box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
        }
        .upload__img-wrap {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-top: 15px;
        }
        .upload__img-box {
          width: 100px;
          height: 100px;
          border-radius: 8px;
          overflow: hidden;
          border: 2px solid #e9ecef;
          position: relative;
        }
        .upload__img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .alert {
          border-radius: 8px;
          padding: 12px 16px;
          margin-bottom: 16px;
          border: 1px solid transparent;
        }
        .alert-success {
          background-color: #d1e7dd;
          border-color: #badbcc;
          color: #0f5132;
        }
        .alert-danger {
          background-color: #f8d7da;
          border-color: #f5c2c7;
          color: #842029;
        }
        .form-text {
          font-size: 0.875rem;
          margin-top: 0.25rem;
        }
        .release__buy:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        .pagination .page-item.disabled .page-link {
          opacity: 0.6;
          cursor: not-allowed;
        }
        .pagination .page-item.active .page-link {
          background-color: #007bff;
          border-color: #007bff;
        }
      `}</style>
    </div>
  );
}

export default Events;
